import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { api } from "@/lib/api";
import { Intro } from "@/components/Intro";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Catalog } from "@/components/Catalog";
import { HowItWorks, Footer, WhatsAppFloat } from "@/components/Footer";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    api.get("/products")
      .then(({ data }) => setProducts(data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
    api.get("/categories").then(({ data }) => setCategories(data)).catch(() => {});
  }, []);

  return (
    <div className="bg-cream min-h-screen" data-testid="home-page">
      <AnimatePresence>
        {!introDone && <Intro onDone={() => setIntroDone(true)} />}
      </AnimatePresence>
      {introDone && (
        <>
          <Nav />
          <Hero />
          <Marquee />
          {loading ? (
            <div className="py-32 text-center text-wood/50 text-sm" data-testid="catalog-loading">
              Carregando catálogo...
            </div>
          ) : (
            <Catalog products={products} categories={categories} />
          )}
          <HowItWorks />
          <Footer />
          <WhatsAppFloat />
        </>
      )}
    </div>
  );
}
